module.exports = {
          srcSet: __webpack_public_path__ + "6f51d354.png"+" 700w"+","+__webpack_public_path__ + "7c41994e.png"+" 1400w"+","+__webpack_public_path__ + "d1ef7cea.png"+" 1600w",
          images:[ {path: __webpack_public_path__ + "6f51d354.png",width: 700,height: 438},{path: __webpack_public_path__ + "7c41994e.png",width: 1400,height: 875},{path: __webpack_public_path__ + "d1ef7cea.png",width: 1600,height: 1000}],
          src: __webpack_public_path__ + "6f51d354.png",
          toString:function(){return __webpack_public_path__ + "6f51d354.png"},
          
          width: 700,
          height: 438
        }